import type { Directive } from 'vue'

// v-ignore-password-manager: stops 1Password from offering to fill the inputs inside the element.
// 1Password only reads data-1p-ignore on the <input> itself, but Vuetify puts data-* attributes on the field's wrapper,
// so every input inside is marked here, also ones added later (e.g. when switching tab)
function markInputs(el: HTMLElement) {
  el.querySelectorAll('input').forEach(input => input.setAttribute('data-1p-ignore', ''))
}

const observers = new WeakMap<HTMLElement, MutationObserver>()

export const vIgnorePasswordManager: Directive<HTMLElement> = {
  mounted(el) {
    markInputs(el)

    // Only watches added elements, so setting the attribute doesn't trigger it again
    const observer = new MutationObserver(() => markInputs(el))
    observer.observe(el, { childList: true, subtree: true })
    observers.set(el, observer)
  },
  unmounted(el) {
    observers.get(el)?.disconnect()
    observers.delete(el)
  }
}
